import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolTextField } from '@synergy/components';
import { useEffect, useState } from 'react';

import { SupplierDocument } from '../models/supplier-detail-document';

export interface SupplierDetailDocumentsEditTitleModalProps {
    document?: SupplierDocument | null;
    onClose: () => void;
    onConfirm: (name: string) => void;
}

export const SupplierDetailDocumentsEditTitleModal = (props: SupplierDetailDocumentsEditTitleModalProps) => {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(prevValue => props.document?.title ?? prevValue);
    }, [props.document]);

    return (
        <PoolModal
            title={<FormattedMessage id="app.contactsAndOrganizations.documents.editTitle" />}
            isVisible={!!props.document}
            handleClose={props.onClose}
            actionChildren={[
                <PoolButton key="1" onClick={props.onClose} styleType="firstLevel" variant="text">
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>,
                <PoolButton key="2" onClick={() => props.onConfirm(value)} styleType="firstLevel">
                    <FormattedMessage id="app.common.save" />
                </PoolButton>,
            ]}
        >
            <PoolTextField
                label={<FormattedMessage id="app.label.title" />}
                value={value}
                onChange={e => setValue(e.target.value)}
                fullWidth={true}
            />
        </PoolModal>
    );
};
